import SvgIcon from "@mui/material/SvgIcon"

export default function PatientListIcon() {
  return (
    <SvgIcon sx={{ marginX: '3px' }}>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(.5)" fill="none" fillRule="evenodd">
          <circle cx="12" cy="12" r="12"/>
          <path d="M16.875 16.125A2.893 2.893 0 0 1 16 14c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 19 11c.833 0 1.542.292 2.125.875S22 13.167 22 14s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 19 17a2.893 2.893 0 0 1-2.125-.875zM13 23v-1.9c0-.35.083-.683.25-1 .167-.317.4-.567.7-.75a9.274 9.274 0 0 1 2.387-1.013C17.18 18.113 18.067 18 19 18c.933 0 1.82.113 2.663.337a9.274 9.274 0 0 1 2.387 1.013c.3.183.533.433.7.75.167.317.25.65.25 1V23H13zm-7-6v-2h8v2H6zm0-8V7h12v2H6zm8.1 4H6v-2h9c-.233.283-.42.592-.563.925A6.002 6.002 0 0 0 14.1 13z" fill="currentColor" fillRule="nonzero"/>
        </g>
      </svg>
    </SvgIcon>
  )
}
